import React from 'react';
import { Row } from '@commonsku/styles';
import Form from './form/AccountStatus';
import useClientStatus from './hooks/useClientStatus';
import TopInfo from './misc/Info';

export default function AdminClientStatus() {
    const [items, loading, save, remove] = useClientStatus();

    const list = items.map((item, index) => {
        return (
            <div key={item.account_status_id} data-testid={`row-${index}`}>
                <Row>
                    <Form item={item} saveItem={save} deleteItem={remove} />
                </Row>
            </div>
        );
    });

    const add = (
        <Row>
            <Form saveItem={save} />
        </Row>
    );

    return (
        <>
            <TopInfo message='Create custom statuses to help segment and analyze client activity on your reports, Clients, and Analytics tabs.' link='https://help.commonsku.com/knowledge/client-details#status' />
            {list}
            {add}
        </>
    );
}
